export const environment = {
  production: false,
  staging: true,
  apiBaseUrl: 'https://artistapistaging.viralwave.net'
};
